'use client';

import { FC, ReactNode } from 'react';
import {
  Tooltip as ShadcnTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';

type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  delayDuration?: number;
  className?: string;
  contentClassName?: string;
};

const Tooltip: FC<TooltipProps> = ({
  content,
  children,
  side = 'bottom',
  align = 'center',
  sideOffset = 4,
  delayDuration = 700,
  className = '',
  contentClassName = '',
}) => {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <ShadcnTooltip>
        <TooltipTrigger asChild className={cn(className)}>
          <span className="inline-flex">{children}</span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'px-2 py-1 text-[12px] normal-case bg-black text-white border-none rounded-[6px]',
            contentClassName,
          )}
        >
          {content}
        </TooltipContent>
      </ShadcnTooltip>
    </TooltipProvider>
  );
};

export { Tooltip };
